import { Settings } from '../store/settings/api/interface';
import { isValidArray } from './valid';

export const fillFaqState = (state: Settings) => {

  const result = state?.value ? JSON.parse(state?.value) : '';

  if (isValidArray(result)) {
    const reqBody = {
      language: state.language,
      items: result?.map((item: any) => {
        const QandA = item?.qaList?.map((element: any) => {
          return {
            question: element?.question ?? '',
            answer: element?.answer ?? '',
          }
        });
        return {
          categoryName: item?.categoryName,
          qaList: QandA,
        }

      }),
    };

    return reqBody;
  } else {
    const reqBody = {
      language: state.language,
      items: [
        {
          categoryName: '',
          qaList: [
            {
              question: '',
              answer: '',
            }
          ],
        },
      ]
    };

    return reqBody;
  }

};